import { forwardRef } from 'react';
import classNames from 'classnames';
import getNativeClassNameStyle from '../../helpers/getNativeClassNameStyle';

/**
 * View
 *
 * @return {JSX.Element}
 */
const View = ({ className, style, ...rest }, ref) => {
  const [localClassName, localStyle] = getNativeClassNameStyle(
    className,
    style
  );

  return (
    <div
      className={classNames(`${View.displayName}`, localClassName)}
      ref={ref}
      style={localStyle}
      {...rest}
    />
  );
};

View.displayName = 'View';

export default forwardRef(View);
